export default {
  title: {
    compare: 'Comparatif patrimoine brut / net',
    brut: 'Composition de votre patrimoine brut',
    net: 'Composition de votre patrimoine net',
  },
  subtitle: 'Vue simplifiée',
  label: {
    brut: 'Brut',
    net: 'Net',
    default: 'Valeur estimée du patrimoine',
    financial: 'Patrimoine financier',
    realEstate: 'Patrimoine immobilier',
    professional: 'Patrimoine professionnel',
    movable: 'Patrimoine mobilier',
  },
}
